/* =====================================================================
   ALB Filter · Horizon Rebuild – vanilla Karussell/Slider Web Component
   Lazy init über IntersectionObserver. prefers-reduced-motion respektiert.
   KEIN externes JS (kein Swiper/Slick). Scroll-Snap-basiert.

   <alb-carousel> umschließt einen [data-track] (scroll-snap-x). Optionale
   Pfeile via [data-prev] / [data-next]. Optionale Auto-Slider-Marquee für
   Kachel-Bänder (data-autoplay) – reine JS-Scrollschleife, kein CSS-Marquee.

   Datenattribute:
     data-autoplay           -> kontinuierliche Auto-Scroll-Schleife
     data-autoplay-speed     -> px/s (Default 40)
   ===================================================================== */
(function () {
  if (customElements.get('alb-carousel')) return;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AlbCarousel extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      var self = this;
      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { self._setup(); self._io.disconnect(); }
          });
        }, { rootMargin: '200px' });
        this._io.observe(this);
      } else {
        this._setup();
      }
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      this._stopAuto();
    }

    _setup() {
      if (this._init) return;
      this._init = true;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');
      var self = this;

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self._scrollByStep(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self._scrollByStep(1); });

      if (this.hasAttribute('data-autoplay') && !REDUCED) {
        this._startAuto();
        this.addEventListener('pointerenter', function () { self._paused = true; });
        this.addEventListener('pointerleave', function () { self._paused = false; });
        this.addEventListener('focusin', function () { self._paused = true; });
        this.addEventListener('focusout', function () { self._paused = false; });
      }
    }

    _step() {
      var card = this.track.querySelector(':scope > *');
      if (!card) return this.track.clientWidth * 0.8;
      var styles = getComputedStyle(this.track);
      var gap = parseInt(styles.columnGap || styles.gap, 10) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    _scrollByStep(dir) {
      this.track.scrollBy({ left: dir * this._step(), behavior: REDUCED ? 'auto' : 'smooth' });
    }

    _startAuto() {
      var self = this;
      var speed = parseFloat(this.getAttribute('data-autoplay-speed')) || 40; // px/s
      var last = null;
      this._paused = false;
      function frame(ts) {
        if (!self._init) return;
        if (last == null) last = ts;
        var dt = (ts - last) / 1000;
        last = ts;
        if (!self._paused) {
          self.track.scrollLeft += speed * dt;
          // nahtlose Schleife: bei Hälfte zurückspringen (Inhalt ist verdoppelt)
          var half = self.track.scrollWidth / 2;
          if (self.track.scrollLeft >= half) self.track.scrollLeft -= half;
        }
        self._raf = window.requestAnimationFrame(frame);
      }
      this._raf = window.requestAnimationFrame(frame);
    }

    _stopAuto() {
      if (this._raf) window.cancelAnimationFrame(this._raf);
      this._raf = null;
    }
  }

  customElements.define('alb-carousel', AlbCarousel);
})();
